import { render } from "./HeroPanel.vue?vue&type=template&id=cef40fd8"
import script from "./HeroPanel.vue?vue&type=script&lang=js"
export * from "./HeroPanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__